/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Gender {
    female = 'female',
    male = 'male',
}

export enum ItemStatus {
    available = 'available',
    draft = 'draft',
    rejected = 'rejected',
}

export enum ItemStyleAccess {
    GROUP = 'GROUP',
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
}

export enum ItemType {
    ITEM = 'ITEM',
    STYLE_REQUEST = 'STYLE_REQUEST',
}

export enum LanguageCode {
    arabic = 'arabic',
    english = 'english',
}

export enum MessageRoleEnum {
    assistant = 'assistant',
    system = 'system',
    user = 'user',
}

export enum MessageScopeEnum {
    external = 'external',
    in_app = 'in_app',
}

export enum MessageTypeEnum {
    ask_user_signup_login = 'ask_user_signup_login',
    connect_to_an_expert_stylist = 'connect_to_an_expert_stylist',
    conversation = 'conversation',
    feedback = 'feedback',
    gender_quiz = 'gender_quiz',
    limitation_notify_message = 'limitation_notify_message',
    personalized_style_exp = 'personalized_style_exp',
    recommendation = 'recommendation',
    recommendation_message = 'recommendation_message',
    regenerate_suggestion = 'regenerate_suggestion',
    reply_positive_feedback = 'reply_positive_feedback',
    stylist_question = 'stylist_question',
    suggest_connect_stylist = 'suggest_connect_stylist',
    user_info = 'user_info',
}

export enum MessageVisibleEnum {
    invisible = 'invisible',
    visible = 'visible',
}

export enum Platform {
    shopify = 'shopify',
    taffi = 'taffi',
}

export enum ProductTypeEnum {
    item = 'item',
    style = 'style',
}

export enum ReleaseFeatureType {
    BUG = 'BUG',
    FEATURE = 'FEATURE',
    OTHER = 'OTHER',
}

export enum StockStatus {
    FALSE = 'FALSE',
    MAYBE = 'MAYBE',
    TRUE = 'TRUE',
}

export enum StyleConversationStatusEnum {
    done = 'done',
    in_conversation = 'in_conversation',
    new_thread = 'new_thread',
}

export enum StyleMessageElementFunctionNameEnum {
    connect_to_stylist = 'connect_to_stylist',
    continue_as_guest = 'continue_as_guest',
    other_option = 'other_option',
    signup = 'signup',
}

export enum StyleMessageElementTemplateEnum {
    message = 'message',
    option = 'option',
}

export enum StyleMessageElementTypeEnum {
    button = 'button',
    image = 'image',
    link = 'link',
    link_option = 'link_option',
    option_message = 'option_message',
    show_more_suggestions = 'show_more_suggestions',
}

export enum StyleStatus {
    draft = 'draft',
    inReview = 'inReview',
    private = 'private',
    published = 'published',
    rejected = 'rejected',
    rejectedFixed = 'rejectedFixed',
    rejectedNotFixed = 'rejectedNotFixed',
    removed = 'removed',
    unlisted = 'unlisted',
    unpublished = 'unpublished',
}

export enum UserAuthType {
    anonymous = 'anonymous',
    authenticated = 'authenticated',
}

export enum UserType {
    admin = 'admin',
    customer = 'customer',
    stylist = 'stylist',
    va = 'va',
}

export enum ValueType {
    BOOLEAN = 'BOOLEAN',
    BOOLEAN_LIST = 'BOOLEAN_LIST',
    FLOAT = 'FLOAT',
    FLOAT_LIST = 'FLOAT_LIST',
    INT = 'INT',
    INT_LIST = 'INT_LIST',
    OBJECT = 'OBJECT',
    OBJECT_LIST = 'OBJECT_LIST',
    QUESTION_DATA = 'QUESTION_DATA',
    QUESTION_DATA_LIST = 'QUESTION_DATA_LIST',
    RANGE = 'RANGE',
    STRING = 'STRING',
    STRING_LIST = 'STRING_LIST',
    UPLOAD_FILE = 'UPLOAD_FILE',
}

export interface AnswerInput {
    messageId: string;
    answer: string;
}

export interface CreateLocalUserInput {
    name: string;
}

export interface GenerateSignedUrlInput {
    filename: string;
    mimetype: string;
    folder: string;
}

export interface GetConsumerConversationInput {
    userId: string;
    paging: PagingInput;
}

export interface GetConversationInput {
    paging: PagingInput;
    lastUpdated?: String;
}
export interface GetSingleConversationInput {
    id?: String;
}

export interface GetItemInput {
    id?: string | null;
    type?: ItemType | null;
    taffiId?: string | null;
    price?: number | null;
    currency?: string | null;
    available?: number | null;
    title?: string | null;
    description?: string | null;
    categoriesId?: (string | null)[] | null;
    tagsId?: (string | null)[] | null;
    labelsId?: (string | null)[] | null;
    url?: string | null;
    maxNumOfStyles?: number | null;
    maxNumOfItems?: number | null;
    userId?: string | null;
    colorsId?: (string | null)[] | null;
    sizesId?: (string | null)[] | null;
    storeId?: string | null;
    storeProductId?: string | null;
    status?: ItemStatus | null;
    paging: PagingInput;
    brandId?: string | null;
}

export interface GetReleaseFeaturesInput {
    version?: string | null;
}

export interface GetStyleInput {
    id?: string | null;
    taffiId?: string | null;
    title?: string | null;
    description?: string | null;
    itemsId?: (string | null)[] | null;
    categoriesId?: (string | null)[] | null;
    tagsId?: (string | null)[] | null;
    labelsId?: (string | null)[] | null;
    userId?: string | null;
    paging: PagingInput;
    status?: StyleStatus | null;
    statusFilter?: (StyleStatus | null)[] | null;
    templates?: (string | null)[] | null;
    sourceId?: string | null;
}

export interface GetUserByUserNameOrIdInput {
    userName: string;
}

export interface MessageInput {
    scope: MessageScopeEnum;
    content: string;
    dynamicContent?: string[] | null;
}

export interface PagingInput {
    size: number;
    page: number;
    orderBy?: string | null;
}

export interface TransformLocalUserDataInput {
    userId: string;
}

export interface UpdateStyleConversationInput {
    id?: string | null;
    message?: MessageInput | null;
    answer?: AnswerInput | null;
    storeId?: string | null;
    numOfStyles?: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
